import { getAmountString, humanizeTermRange } from '../../helpers/humanization.js';

const getMicrocreditsTerms = item => {
    const conditions = [];
    const { details } = item;
    const maxRange = getAmountString(details.amount.to, details.currency);
    conditions.push({ value: maxRange, description: 'Сумма до', key: 'maxRange' });
    const termRange = humanizeTermRange(details.term, {
        termWithUnit: true,
        initialForm: false,
        prepositions: true,
    });
    conditions.push({ value: termRange, description: 'Срок (дни)', key: 'term' });
    return conditions;
};

export { getMicrocreditsTerms };
//# sourceMappingURL=microcredits.js.map
